// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__22QoW","Label":"BuildControl_Label__3N4-W","Less":"BuildControl_Less__1Mw1K","More":"BuildControl_More__exRpE"};